export default "/images/vendor/flag-icons/flags/1x1/bi.svg?d444ab39f267ef8a50ef2f9ee058afdf";